// extracted by mini-css-extract-plugin
module.exports = {"carousel-wrapper":"CarouselWrapper_carousel-wrapper__eRu04"};